import * as React from 'react'

import Popup from '../../../ui/popup'
import Button from '../../../ui/button'

interface Props {
    onClose: () => void
    onDelete: () => void
}

const DeleteGuestbookMessage: React.FunctionComponent<Props> = ({ onClose, onDelete }: Props) => {
    return (
        <Popup
            onClose={onClose}
            title="Are you sure?"
            text="Do you really want to delete this message"
            classname="vertical"
            buttons={
                <>
                    <Button label="Delete" onClick={onDelete} />
                    <Button label="Cancel" secondary onClick={onClose} />
                </>
            }
            profile={true}
        />
    )
}

export default DeleteGuestbookMessage
